import { render } from "./SectionMainside.vue?vue&type=template&id=6057171c&scoped=true"
import script from "./SectionMainside.vue?vue&type=script&lang=js"
export * from "./SectionMainside.vue?vue&type=script&lang=js"

import "./SectionMainside.vue?vue&type=style&index=0&id=6057171c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6057171c"]])

export default __exports__